import React from "react";
import Footer from "../../components/footer/Footer";
import Newsletter from "../../components/newsletter/Newsletter";
import {
  TermsPageContainer,
  TermsPageTable,
  TermsResultCard,
} from "./TermsStyles";

function Terms() {
  return (
    <TermsPageContainer>
      <TermsPageTable>
        <TermsResultCard>
          <b>ALGEMENE VOORWAARDEN Smart-Personeel</b>
          <hr />
          <b>1. INLEIDING</b>
          <b>1.1. Doel en Toepasselijkheid van de Algemene Voorwaarden</b>
          Deze algemene voorwaarden zijn van toepassing op alle aanbiedingen,
          opdrachten, en overeenkomsten tussen Smart-Personeel en haar
          opdrachtgevers betreffende uitzenden, detacheren, werving & selectie,
          en bemiddeling van ZZP’ers. Afwijkingen van deze voorwaarden zijn
          alleen geldig indien deze schriftelijk zijn overeengekomen. Eventuele
          inkoop- of andere voorwaarden van de opdrachtgever worden
          uitdrukkelijk van de hand gewezen.
          <br />
          <b>1.2. Definities</b>
          <ul style={{ marginLeft: "20px" }}>
            <li>
              Smart-Personeel: De bemiddelingsorganisatie die zorgpersoneel
              uitzendt, detacheert en bemiddelt.
            </li>
            <li>
              Opdrachtgever: Iedere natuurlijke of rechtspersoon die
              gebruikmaakt van de diensten van Smart-Personeel.
            </li>
            <li>
              Kandidaat: Een persoon die door Smart-Personeel is geselecteerd
              voor een positie bij de opdrachtgever.
            </li>
            <li>
              ZZP’er: Zelfstandige Zonder Personeel, bemiddeld door
              Smart-Personeel op basis van een bemiddelingsovereenkomst.
            </li>
            <li>
              Uitzendkracht: Een persoon die door Smart-Personeel wordt
              uitgezonden naar een opdrachtgever.
            </li>
            <li>
              Detachering: Het ter beschikking stellen van personeel voor een
              vooraf overeengekomen periode.
            </li>
            <li>
              Overeenkomst: De schriftelijke overeenkomst tussen Smart-Personeel
              en de opdrachtgever voor het leveren van diensten.
            </li>
            <li>
              Backofficer: De payroll-organisatie die de juridische werkgever is
              van de uitzendkrachten en gedetacheerden die door Smart-Personeel
              ter beschikking worden gesteld aan de opdrachtgever. Backofficer
              draagt zorg voor de loonadministratie, afdracht van sociale
              premies en belastingen, en andere wettelijke verplichtingen ten
              aanzien van de uitzendkrachten en gedetacheerden.
            </li>
          </ul>
          <b>1.3. Wijzigingen van de Algemene Voorwaarden</b>
          Smart-Personeel behoudt zich het recht voor om de algemene voorwaarden
          eenzijdig te wijzigen. Wijzigingen worden schriftelijk bekendgemaakt
          en zijn van toepassing één maand na deze bekendmaking, tenzij anders
          is overeengekomen. Indien de opdrachtgever niet akkoord gaat met de
          wijzigingen, kan hij de overeenkomst schriftelijk opzeggen binnen 14
          dagen na de bekendmaking. De opzegging kan plaatsvinden zonder enige
          verplichting tot schadevergoeding.
          <br />
          <b>1.4. Tarieven</b>
          Alle in deze algemene voorwaarden vermelde tarieven en vergoedingen
          zijn exclusief btw, tenzij uitdrukkelijk anders is aangegeven.  <br />
          <b>2. DIENSTEN VAN SMART-PERSONEEL</b>
          <b>2.1. Uitzenden</b>
          <b>2.1.1. Definitie:</b> Uitzenden is de dienst waarbij
          Smart-Personeel een werknemer (uitzendkracht) ter beschikking stelt
          aan een opdrachtgever. De uitzendkracht werkt onder leiding en
          toezicht van de opdrachtgever, terwijl de arbeidsovereenkomst wordt
          aangegaan tussen de uitzendkracht en Smart-Personeel. De opdrachtgever
          betaalt aan Smart-Personeel een vergoeding voor de gewerkte uren van
          de uitzendkracht.
          <b>2.1.2. Verantwoordelijkheden Smart-Personeel bij uitzenden:</b>
          Smart-Personeel selecteert de kandidaten en stelt deze ter beschikking
          aan de opdrachtgever. Backofficer fungeert daarbij als juridisch
          werkgever van de uitzendkrachten en gedetacheerden, en is
          verantwoordelijk voor de loonbetaling, afdracht van sociale premies,
          belastingen, en de naleving van arbeidsrechtelijke verplichtingen.
          Indien Backofficer zijn verplichtingen niet nakomt, zoals het betalen
          van lonen of afdracht van sociale premies, is Backofficer
          aansprakelijk voor de schade die hieruit voortvloeit. Smart-Personeel
          kan in dergelijke gevallen niet aansprakelijk worden gesteld.
          <b>2.1.3. Toepasselijkheid van de CAO:</b> De arbeidsvoorwaarden van
          de uitzendkrachten zijn onderworpen aan de CAO voor Uitzendkrachten.
          Backofficer draagt zorg voor de naleving van de cao-bepalingen, zoals
          beloningsstructuren, vakantiedagen, en andere arbeidsvoorwaarden,
          terwijl Smart-Personeel de selectie en inzet van de kandidaten
          verzorgt.
          <b>2.1.4. Inlenersbeloning:</b> De inlenersbeloning, zoals
          gedefinieerd in de CAO, wordt toegepast vanaf de eerste werkdag van de
          uitzendkracht. Dit betekent dat de uitzendkracht recht heeft op
          dezelfde beloning als de werknemers van de opdrachtgever in gelijke
          functies, met inbegrip van loon, toeslagen, onkostenvergoedingen,
          periodieken, en overige emolumenten. De opdrachtgever is verplicht om
          tijdig en volledig informatie te verstrekken over de bij hem geldende
          arbeidsvoorwaarden, zodat Smart-Personeel deze kan toepassen voor de
          uitzendkracht.
          <b>2.1.5. Uitzendbeding:</b> Indien van toepassing kan een
          uitzendovereenkomst met een uitzendbeding worden aangegaan. Het
          uitzendbeding houdt in dat de arbeidsovereenkomst tussen
          Smart-Personeel en de uitzendkracht van rechtswege eindigt wanneer de
          terbeschikkingstelling van de uitzendkracht aan de opdrachtgever
          eindigt. Dit kan op verzoek van de opdrachtgever of door een andere
          reden zoals ziekte van de uitzendkracht. Smart-Personeel zal de
          opdrachtgever hierover informeren en tijdig schriftelijke bevestiging
          ontvangen.
          <b>2.1.6. Proeftijd en garantieperiode voor uitzendkrachten:</b>{" "}
          Gedurende de eerste maand, voor zover wettelijk en/of conform CAO
          toegestaan, heeft de opdrachtgever de mogelijkheid om de overeenkomst
          zonder opgave van redenen te beëindigen als de uitzendkracht niet aan
          de verwachtingen voldoet. Smart-Personeel zorgt in dat geval voor
          kosteloze vervanging, mits de redenen schriftelijk worden gemeld.
          Mocht er sprake zijn van een uitzendbeding dan geld er geen
          proefperiode. Binnen een redelijke termijn levert Smart-Personeel
          vervanging zonder werving en selectiekosten in rekening te brengen.
          <b>2.1.7. Uurtarieven en flexibiliteit van inzet:</b> Smart-Personeel
          rekent een uurtarief dat is afgestemd op de functie en ervaring van de
          uitzendkracht. Tariefaanpassingen kunnen plaatsvinden bij wijzigingen
          in wetgeving, cao-bepalingen, of andere relevante omstandigheden. Alle
          tarieven zijn exclusief btw.
          <b>2.1.8. In dienst nemen van een uitzendkracht:</b> Indien de
          opdrachtgever een door Smart-Personeel ingezette uitzendkracht in
          dienst wil nemen tijdens de uitzendperiode of binnen 12 maanden na
          beëindiging van de uitzendovereenkomst, is de opdrachtgever een
          vergoeding verschuldigd van 25% van het bruto jaarinkomen van de
          uitzendkracht. Deze vergoeding wordt berekend op basis van het tussen
          de uitzendkracht en de opdrachtgever overeengekomen bruto
          maandsalaris, inclusief vakantiegeld en andere emolumenten. Echter,
          indien de uitzendkracht gedurende de uitzendperiode 1680 uren voor de
          opdrachtgever heeft gewerkt middels Smart-Personeel, mag de
          opdrachtgever de uitzendkracht kosteloos overnemen. De 1680 gewerkte
          uren worden berekend op basis van daadwerkelijk gewerkte uren bij de
          opdrachtgever, exclusief vakantiedagen, ziekteverzuim, en andere
          vormen van afwezigheid. Indien de opdrachtgever de uitzendkracht
          zonder toestemming van Smart-Personeel rechtstreeks in dienst neemt,
          is de opdrachtgever alsnog gehouden de overeengekomen vergoeding van
          25% van het bruto jaarinkomen van de uitzendkracht aan Smart-Personeel
          te betalen.
          <b>2.2. Detacheren</b>
          <b>2.2.1. Definitie:</b> Detacheren is de dienst waarbij
          Smart-Personeel een werknemer (gedetacheerde) voor een vooraf
          overeengekomen periode aan een opdrachtgever ter beschikking stelt.
          Gedurende de detachering blijft de gedetacheerde in dienst van
          Smart-Personeel, maar werkt hij/zij onder leiding en toezicht van de
          opdrachtgever. Smart-Personeel is verantwoordelijk voor de selectie
          van kandidaten, terwijl Backofficer de juridische werkgever is.
          <b>2.2.2. Verantwoordelijkheden Smart-Personeel bij detacheren:</b>
          Smart-Personeel selecteert de kandidaten en stelt deze ter beschikking
          aan de opdrachtgever. Backofficer fungeert daarbij als juridisch
          werkgever van de gedetacheerden, en is verantwoordelijk voor de
          loonbetaling, afdracht van sociale premies, belastingen, en de
          naleving van arbeidsrechtelijke verplichtingen. Indien Backofficer
          zijn verplichtingen niet nakomt, zoals het betalen van lonen of
          afdracht van sociale premies, is Backofficer aansprakelijk voor de
          schade die hieruit voortvloeit. Smart-Personeel kan in dergelijke
          gevallen niet aansprakelijk worden gesteld.
          <b>2.2.3. Toepasselijkheid van de CAO:</b> De arbeidsvoorwaarden van
          gedetacheerden zijn onderworpen aan de CAO voor Uitzendkrachten.
          Backofficer draagt zorg voor de naleving van de cao-bepalingen, zoals
          beloningsstructuren, vakantiedagen, en andere arbeidsvoorwaarden,
          terwijl Smart-Personeel de selectie en inzet van de kandidaten
          verzorgt.
          <b>2.2.4. Inlenersbeloning:</b> Indien van toepassing wordt de
          inlenersbeloning gehanteerd, zoals bepaald in de relevante CAO. Dit
          houdt in dat de gedetacheerde recht heeft op dezelfde beloning als de
          medewerkers van de opdrachtgever in een vergelijkbare functie,
          inclusief loon, toeslagen, periodieken, en andere emolumenten. De
          opdrachtgever is verplicht om Smart-Personeel tijdig en volledig te
          informeren over de bij hem geldende arbeidsvoorwaarden en
          beloningsregelingen, zodat deze juist kunnen worden toegepast.
          <b>2.2.5. Looptijd en afspraken over detacheringsovereenkomsten:</b>
          Detacheringsovereenkomsten worden aangegaan voor een vooraf bepaalde
          periode, met een minimumduur van drie maanden. In de overeenkomst
          worden de taken, verantwoordelijkheden, werkuren, en eventuele
          specifieke voorwaarden vastgelegd. Een detachering kan voor bepaalde
          of onbepaalde tijd worden overeengekomen, afhankelijk van de behoefte
          van de opdrachtgever.
          <b>2.2.6. Proeftijd en evaluatieperiode:</b> Bij een overeenkomst van
          6 maanden of langer geld iIn de eerste maand van de detachering geldt
          een evaluatieperiode waarin de opdrachtgever de mogelijkheid heeft om
          de overeenkomst schriftelijk te beëindigen indien de gedetacheerde
          niet aan de gestelde eisen voldoet. Gedurende deze periode zorgt
          Smart-Personeel bij een redelijke klacht voor kosteloze vervanging
          binnen een redelijke termijn.
          <b>2.2.7. Vervanging van gedetacheerden:</b> Indien de gedetacheerde
          vanwege ziekte, gebrek aan geschiktheid of andere redenen niet meer
          kan worden ingezet, zal Smart-Personeel zich inspannen om een
          geschikte vervanger aan te bieden. De vervanging geschiedt in overleg
          met de opdrachtgever en binnen een redelijke termijn.
          <b>2.2.8. Opzegvoorwaarden:</b> Tussentijdse opzegging van de
          detacheringsovereenkomst door de opdrachtgever kan uitsluitend
          schriftelijk en met inachtneming van een opzegtermijn van 30 dagen,
          tenzij anders is overeengekomen. Smart-Personeel heeft bij
          tussentijdse opzegging recht op vergoeding voor reeds gemaakte kosten
          en schade als gevolg van de beëindiging.
          <b>2.2.9. Uurtarieven en vergoeding:</b> De tarieven voor detachering
          zijn gebaseerd op de functie, ervaring en het gewenste
          opleidingsniveau van de gedetacheerde. Het tarief wordt overeengekomen
          bij aanvang van de detachering en kan tijdens de looptijd worden
          aangepast indien de functie-inhoud significant wijzigt of er andere
          omstandigheden zijn, zoals cao-wijzigingen. Alle tarieven zijn
          exclusief btw.
          <b>2.2.10. In dienst nemen van een gedetacheerde:</b> Indien de
          opdrachtgever een door Smart-Personeel gedetacheerde werknemer
          rechtstreeks in dienst wil nemen tijdens de detacheringsperiode of
          binnen 12 maanden na beëindiging van de detacheringsovereenkomst, is
          een vergoeding verschuldigd aan Smart-Personeel. De vergoeding
          bedraagt 25% van het bruto jaarinkomen van de gedetacheerde, gebaseerd
          op het afgesproken maandsalaris, inclusief vakantiegeld, bonussen en
          andere emolumenten. Echter, indien de gedetacheerde gedurende de
          detacheringsperiode 1680 uren voor de opdrachtgever heeft gewerkt
          middels Smart-Personeel, mag de opdrachtgever de gedetacheerde
          kosteloos overnemen. De 1680 gewerkte uren worden berekend op basis
          van daadwerkelijk gewerkte uren bij de opdrachtgever, exclusief
          vakantiedagen, ziekteverzuim, en andere vormen van afwezigheid.
          <b>2.3. Werving & Selectie</b>
          <b>2.3.1. Definitie:</b> Werving & Selectie is de dienst waarbij
          Smart-Personeel geschikte kandidaten werft en selecteert voor een
          directe indiensttreding bij de opdrachtgever. De kandidaat komt
          rechtstreeks in dienst van de opdrachtgever, en Smart-Personeel
          ontvangt hiervoor een eenmalige vergoeding, berekend als een
          percentage van het bruto jaarinkomen van de geplaatste kandidaat.
          <b>
            2.3.2. Toepassing van het "no cure no pay"-model bij succesvolle
            plaatsing:
          </b>
          Smart-Personeel werkt op basis van een "no cure no pay"-model, waarbij
          de opdrachtgever enkel een vergoeding verschuldigd is bij een
          succesvolle plaatsing van een kandidaat. De vergoeding bedraagt een
          percentage van het bruto jaarinkomen van de geplaatste kandidaat,
          tenzij anders schriftelijk is overeengekomen.
          <b>2.3.3. Bepaling van het bruto jaarinkomen:</b> Het bruto
          jaarinkomen omvat het tussen de kandidaat en de opdrachtgever
          overeengekomen bruto maandsalaris op basis van een fulltime
          dienstverband (36 uur per week), omgerekend naar een jaarsalaris
          inclusief vakantiegeld, dertiende maand, en andere gegarandeerde
          emolumenten volgens de toepasbare CAO.
          <b>
            2.3.4. Uitzonderingen waarbij kosten in rekening worden gebracht:
          </b>
          Indien aanvullende werkzaamheden of extra kosten moeten worden
          gemaakt, zoals exclusieve zoekopdrachten, advertentiekosten,
          assessments of andere specifieke voorbereidingskosten, zullen deze
          enkel worden ingezet en gefactureerd na voorafgaand schriftelijk
          akkoord van de opdrachtgever.
          <b>2.3.5. Garantie op plaatsing:</b> Smart-Personeel biedt een
          garantieperiode van één maand op de plaatsing van een kandidaat.
          Indien de arbeidsovereenkomst tussen de kandidaat en de opdrachtgever
          binnen deze periode wordt beëindigd (anders dan door een
          reorganisatie, verandering van functie-eisen of wanprestatie van de
          opdrachtgever), zal Smart-Personeel zonder bijkomende kosten een
          nieuwe kandidaat aanleveren, mits:
          <ul style={{ marginLeft: "20px" }}>
            <li>
              De opdrachtgever binnen zeven dagen na de beëindiging schriftelijk
              melding maakt bij Smart-Personeel.
            </li>
            <li>
              De functie, werkomstandigheden en arbeidsvoorwaarden ongewijzigd
              zijn ten opzichte van de oorspronkelijke overeenkomst.
            </li>
            <li>
              De beëindiging niet het gevolg is van afvloeiing, reorganisatie,
              fusie of overname binnen de organisatie van de opdrachtgever.
            </li>
            <li>
              De opdrachtgever alle openstaande betalingen aan Smart-Personeel
              heeft voldaan.
            </li>
          </ul>
          <b>2.3.6. Annuleringsvoorwaarden door de opdrachtgever:</b> Annulering
          van opdracht dient schriftelijk te geschieden. Bij annulering van de
          opdracht na de introductie van kandidaten door Smart-Personeel is de
          volledige werving & selectie fee verschuldigd. Bij annulering vóór de
          introductie van kandidaten zijn enkel de eventueel gemaakte kosten
          verschuldigd.
          <b>2.3.7. Voorwaarden voor overname bij Werving & Selectie:</b> Indien
          de opdrachtgever een door Smart-Personeel voorgestelde kandidaat
          binnen 12 maanden na de eerste introductie door Smart-Personeel
          rechtstreeks in dienst neemt, zonder dat Smart-Personeel verder
          betrokken is, is de opdrachtgever de volledige werving & selectie fee
          verschuldigd. Dit geldt ook als de kandidaat zelf solliciteert bij de
          opdrachtgever of indien de opdrachtgever de kandidaat benadert buiten
          Smart-Personeel om. De vergoeding bedraagt het percentage van het
          bruto jaarinkomen van de kandidaat, zoals overeengekomen in de
          overeenkomst.
          <b>2.4. ZZP Bemiddeling</b>
          <b>2.4.1. Definitie:</b> ZZP Bemiddeling is de dienst waarbij
          Smart-Personeel bemiddelt tussen opdrachtgevers en zelfstandigen
          zonder personeel (ZZP’ers). Smart-Personeel faciliteert de
          totstandkoming van een overeenkomst van opdracht tussen de ZZP’er en
          de opdrachtgever, waarbij de ZZP’er zelfstandig en voor eigen rekening
          werkzaamheden uitvoert bij de opdrachtgever. Smart-Personeel
          ondersteunt hierbij door:
          <ul style={{ marginLeft: "20px" }}>
            <li>
              Het screenen van de ZZP’er op geschiktheid, ervaring en
              kwalificaties.
            </li>
            <li>
              Het verifiëren van de benodigde documenten, zoals de inschrijving
              bij de Kamer van Koophandel en beroepsverzekeringen.
            </li>
            <li>
              Het opstellen en vastleggen van de bemiddelingsovereenkomst.
            </li>
            <li>
              Het bieden van advies over compliance, zoals de juiste toepassing
              van de Wet DBA.
            </li>
          </ul>
          De ZZP’er voert de werkzaamheden uit als zelfstandige en draagt de
          verantwoordelijkheid voor het zelfstandig ondernemen, inclusief het
          bepalen van werkuren en het dragen van financiële en operationele
          risico’s. Er is geen sprake van een arbeidsovereenkomst tussen
          Smart-Personeel en de ZZP’er, noch tussen de opdrachtgever en de
          ZZP’er. De ZZP’er declareert zijn of haar gewerkte uren bij de
          opdrachtgever, terwijl Smart-Personeel een bemiddelingsvergoeding
          ontvangt op basis van de door de ZZP’er bij de opdrachtgever
          gedeclareerde omzet.
          <b>
            2.4.2. Verantwoordelijkheden van Smart-Personeel bij bemiddeling van
            ZZP’ers:
          </b>{" "}
          Smart-Personeel bemiddelt tussen opdrachtgevers en ZZP’ers en zorgt
          voor een correcte vastlegging van afspraken in een
          bemiddelingsovereenkomst. Smart-Personeel ondersteunt bij het naleven
          van de relevante wet- en regelgeving, zoals de Wet DBA, en biedt
          begeleiding bij compliance-vraagstukken, zoals het aanleveren van de
          juiste documenten.
          <b>2.4.3. Garantie op beschikbaarheid en vervanging van ZZP’ers:</b>
          Smart-Personeel doet haar best om geschikte vervanging te vinden
          indien een ZZP’er niet beschikbaar blijkt te zijn voor een opdracht.
          <b>2.4.4. Voorwaarden voor in dienst nemen van een ZZP’er:</b> Indien
          de opdrachtgever een door Smart-Personeel voorgestelde ZZP’er
          rechtstreeks in dienst wil nemen of zonder tussenkomst van
          Smart-Personeel inschakelt voor opdrachten binnen 12 maanden na de
          bemiddelingsovereenkomst, is de opdrachtgever een vergoeding
          verschuldigd aan Smart-Personeel. Deze vergoeding bedraagt 25% van de
          door de ZZP’er verwachte jaaromzet bij de opdrachtgever, gebaseerd op
          het eerder overeengekomen uurtarief en de verwachte inzet.
          <b>2.4.5. Berekening van de verwachte jaaromzet:</b> De verwachte
          jaaromzet wordt berekend door het overeengekomen uurtarief van de
          ZZP’er te vermenigvuldigen met het gemiddelde aantal uren per week dat
          hij of zij bij de opdrachtgever zal werken, en vervolgens
          vermenigvuldigd met 52 weken.
          <b>
            2.4.6. Inhuren van een ZZP'er via een ander bemiddelingsbureau:
          </b>{" "}
          Indien de opdrachtgever een ZZP’er die eerder via Smart-Personeel bij
          de opdrachtgever is bemiddeld, binnen 12 maanden na de
          bemiddelingsovereenkomst inschakelt via een ander bemiddelingsbureau,
          is de opdrachtgever een vergoeding verschuldigd aan Smart-Personeel.
          Deze vergoeding bedraagt 25% van de door de ZZP’er verwachte jaaromzet
          bij de opdrachtgever, gebaseerd op het eerder overeengekomen uurtarief
          en de verwachte inzet. Dit is van toepassing ongeacht of de ZZP’er
          zelfstandig of via een ander bemiddelingsbureau wordt ingehuurd, en
          ongeacht de aard van de werkzaamheden waarvoor de ZZP’er wordt
          ingezet.
          <b>2.4.7. Aansprakelijkheid bij bemiddeling van ZZP'ers:</b>{" "}
          Smart-Personeel kan niet aansprakelijk worden gesteld voor eventuele
          fiscale of juridische gevolgen die voortvloeien uit de samenwerking
          tussen de ZZP'er en de opdrachtgever, tenzij deze direct het gevolg
          zijn van grove nalatigheid of opzet van Smart-Personeel. De
          opdrachtgever is verantwoordelijk voor de juiste beoordeling van de
          fiscale positie van de ZZP’er en de naleving van relevante wet- en
          regelgeving.
          <b>3. VERPLICHTINGEN VAN SMART-PERSONEEL</b>
          <b>3.1. Kwaliteit en Zorgvuldigheid van Dienstverlening</b>
          Smart-Personeel zal zich inspannen om de opdracht naar behoren uit te
          voeren, met inachtneming van de eisen van goed vakmanschap,
          zorgvuldigheid en de relevante wet- en regelgeving. Smart-Personeel
          streeft ernaar om geschikte kandidaten voor te dragen die voldoen aan
          de door de opdrachtgever gestelde eisen. Smart-Personeel kan echter
          geen garantie geven dat elke voorgedragen kandidaat geschikt is voor
          de specifieke behoeften van de opdrachtgever.
          <b>3.2. Verantwoordelijkheid voor Geselecteerde Kandidaten</b>
          Hoewel Smart-Personeel zorgvuldig geselecteerde kandidaten voorstelt
          aan de opdrachtgever, blijft de opdrachtgever verantwoordelijk voor de
          uiteindelijke beoordeling van de geschiktheid van de kandidaat. De
          opdrachtgever is zelf verantwoordelijk voor het controleren van
          referenties, diploma’s en overige relevante informatie van de
          kandidaat. Smart-Personeel kan niet aansprakelijk worden gesteld
          indien een kandidaat niet voldoet aan de door de opdrachtgever
          gestelde verwachtingen.
          <b>3.3. Geheimhouding en Privacy</b>
          Smart-Personeel behandelt alle informatie die zij ontvangt van de
          opdrachtgever, kandidaat, en ZZP’er als strikt vertrouwelijk.
          Smart-Personeel zal vertrouwelijke informatie uitsluitend gebruiken
          voor het uitvoeren van de overeenkomst en zal deze niet aan derden
          verstrekken, tenzij dit noodzakelijk is voor de uitvoering van de
          overeenkomst of wanneer dit op grond van wet- en regelgeving vereist
          is. Smart-Personeel verwerkt persoonsgegevens van kandidaten, ZZP’ers
          en opdrachtgevers conform de Algemene Verordening Gegevensbescherming
          (AVG). Smart-Personeel heeft passende technische en organisatorische
          maatregelen genomen om de veiligheid van de persoonsgegevens te
          waarborgen. De opdrachtgever is verantwoordelijk voor het verstrekken
          van correcte gegevens en vrijwaart Smart-Personeel voor eventuele
          aanspraken van derden in verband met onjuiste verstrekte gegevens.
          <b>3.4. Verdeling van Verantwoordelijkheden met Backofficer</b>
          Smart-Personeel fungeert als bemiddelingspartner en zorgt voor de
          juiste match tussen kandidaten en opdrachtgevers. Backofficer treedt
          op als juridisch werkgever van de ter beschikking gestelde
          uitzendkrachten en gedetacheerden. De administratieve en juridische
          verplichtingen met betrekking tot de uitzendkrachten en
          gedetacheerden, zoals loonadministratie, afdracht van sociale premies
          en verzekeringen, zijn de verantwoordelijkheid van Backofficer.
          Smart-Personeel en Backofficer werken nauw samen om te zorgen voor de
          naleving van alle arbeidsrechtelijke en fiscale verplichtingen
          richting de uitzendkrachten en gedetacheerden. Smart-Personeel zal
          Backofficer voorzien van alle noodzakelijke informatie over de
          uitzendkrachten en gedetacheerden, zoals arbeidscontracten, werkuren
          en functieomschrijvingen. Backofficer is verantwoordelijk voor de
          verwerking van deze gegevens conform de AVG. Eventuele vragen of
          verzoeken van de opdrachtgever over betalingen, arbeidsovereenkomsten
          of personeelsdossiers worden door Backofficer afgehandeld.
          <b>4. VERPLICHTINGEN VAN DE OPDRACHTGEVER</b>
          <b>4.1. Correcte en Tijdige Informatievoorziening</b>
          De opdrachtgever dient alle benodigde informatie tijdig en volledig
          aan Smart-Personeel te verstrekken, zodat Smart-Personeel haar
          werkzaamheden correct kan uitvoeren. De opdrachtgever is
          verantwoordelijk voor de juistheid van de verstrekte informatie en
          vrijwaart Smart-Personeel voor eventuele schade die voortvloeit uit
          onjuiste of onvolledige informatie.
          <b>4.2. Betaling van Facturen</b>
          Facturen dienen door de opdrachtgever binnen 14 dagen na factuurdatum
          te worden voldaan, tenzij schriftelijk anders is overeengekomen. Bij
          niet-tijdige betaling is de opdrachtgever van rechtswege in verzuim en
          is wettelijke rente verschuldigd vanaf de vervaldatum van de factuur.
          <b>4.3. Verantwoordelijkheden t.a.v. Arbeidsomstandigheden</b>
          De opdrachtgever blijft verantwoordelijk voor de veilige en gezonde
          werkomstandigheden van de uitzendkrachten en gedetacheerden, zoals
          vastgelegd in de Arbeidsomstandighedenwet. Hoewel Backofficer
          juridisch werkgever is, blijft de opdrachtgever verantwoordelijk voor
          het naleven van de verplichtingen rondom veiligheid op de werkplek en
          het dagelijks toezicht op de uitzendkrachten en gedetacheerden. De
          opdrachtgever dient tijdig alle relevante informatie over de werkplek,
          functie-eisen, en de inlenersbeloning aan zowel Smart-Personeel als
          Backofficer te verstrekken.
          <b>4.4. Consequenties van Niet-Tijdige Betaling van Facturen</b>
          Indien de opdrachtgever niet tijdig betaalt, is de opdrachtgever van
          rechtswege in verzuim zonder dat daarvoor een ingebrekestelling
          vereist is. In dat geval is de opdrachtgever een vertragingsrente van
          1% per maand verschuldigd, waarbij een deel van een maand als een
          volledige maand wordt beschouwd. Tevens is de opdrachtgever gehouden
          tot vergoeding van alle buitengerechtelijke incassokosten, welke
          worden vastgesteld op 15% van de openstaande hoofdsom met een minimum
          van €150. Smart-Personeel is gerechtigd de uitvoering van de diensten
          op te schorten tot volledige betaling van de openstaande bedragen is
          ontvangen. Voordat de opschorting plaatsvindt, zal Smart-Personeel de
          opdrachtgever schriftelijk waarschuwen en een termijn van 7 dagen
          geven om alsnog aan de betalingsverplichting te voldoen.
          <b>4.5. Verzekeringen voor Werknemers</b>
          De opdrachtgever dient voldoende verzekerd te zijn voor risico’s met
          betrekking tot de ter beschikking gestelde medewerkers, zoals
          wettelijke aansprakelijkheid en schade door arbeidsongevallen op de
          werkplek.
          <b>5. TARIEFSTRUCTUUR EN BETALINGSVOORWAARDEN</b>
          <b>5.1. Tarieven voor Uitzenden en Detacheren</b>
          De tarieven voor uitzenden en detacheren zijn gebaseerd op de functie
          van de kandidaat en worden per uur berekend. Tariefwijzigingen als
          gevolg van cao-aanpassingen kunnen tijdens de opdracht worden
          doorgevoerd. Alle tarieven zijn exclusief btw.
          <b>5.2. Tarieven voor Werving & Selectie</b>
          De vergoeding voor werving & selectie bedraagt een percentage van het
          bruto jaarsalaris van de geplaatste kandidaat, inclusief vakantiegeld
          en andere emolumenten. De exacte percentages worden vastgelegd in de
          overeenkomst met de opdrachtgever. De opdrachtgever is gehouden deze
          vergoeding binnen 14 dagen na facturatie te voldoen.
          <b>5.3. Bemiddelingsvergoeding ZZP</b>
          Smart-Personeel hanteert een bemiddelingsvergoeding voor ZZP’ers,
          gebaseerd op de door de ZZP’er bij de opdrachtgever gedeclareerde
          omzet. Deze vergoeding wordt vooraf overeengekomen en in de
          bemiddelingsovereenkomst vastgelegd. 5.4. Standaardtarieven en
          Omrekenfactoren
          <b>
            Smart-Personeel hanteert de volgende standaardtarieven voor haar
            diensten:
          </b>
          <b>5.4.1. Omrekenfactor voor Uitzenduren:</b> De standaard
          omrekenfactor voor uitzenduren is 2,35. Deze factor wordt gebruikt om
          de loonkosten van de uitzendkracht om te rekenen naar het uurtarief
          dat aan de opdrachtgever in rekening wordt gebracht. Dit tarief omvat
          onder andere de loonkosten, werkgeverslasten, sociale premies en
          administratieve kosten.
          <b>5.4.2. Detacheren: </b>De standaard omrekenfactor voor
          detacheringsuren is 2,35.
          <b>5.4.3. Werving & Selectie:</b> Het standaard fee-percentage voor
          werving en selectie bedraagt 22,5% van het bruto jaarinkomen van de
          geplaatste kandidaat. Dit percentage geldt voor zowel tijdelijke als
          vaste aanstellingen, tenzij schriftelijk anders is overeengekomen.
          <b>5.4.4. Bemiddeling ZZP:</b> bemiddeling fee over de door de ZZP’er
          bij de opdrachtgever gedeclareerde omzet, met een minimumtarief van €
          7,=- per gewerkt uur.. Tarieven voor reguliere uren, voor overwerk,
          avond- en weekenddiensten zijn beschikbaar op verzoek en worden in de
          overeenkomst gespecificeerd.
          <b>5.5. Betalingstermijnen en Incasso</b>
          Betaling van facturen dient binnen 14 dagen na factuurdatum te
          geschieden, tenzij anders schriftelijk overeengekomen. Indien een
          factuur niet tijdig wordt betaald, is de opdrachtgever van rechtswege
          in verzuim zonder dat daarvoor een ingebrekestelling vereist is. In
          dat geval is de opdrachtgever een vertragingsrente van 1% per maand
          verschuldigd, waarbij een deel van een maand als een volledige maand
          wordt beschouwd. Smart-Personeel behoudt zich het recht voor om bij
          uitblijven van betaling de uitvoering van de diensten op te schorten
          totdat de openstaande betalingen volledig zijn voldaan. Voordat de
          opschorting plaatsvindt, zal Smart-Personeel de opdrachtgever
          schriftelijk waarschuwen en een termijn van 7 dagen geven om alsnog
          aan de betalingsverplichting te voldoen.
          <b>6. AANSPRAKELIJKHEID</b>
          <b>6.1. Aansprakelijkheid van Smart-Personeel en Backofficer</b>
          Smart-Personeel is niet aansprakelijk voor schade die voortvloeit uit
          de loonbetalingen of administratieve verplichtingen die vallen onder
          de verantwoordelijkheid van Backofficer als juridisch werkgever.
          Backofficer is aansprakelijk voor de juiste en tijdige afdracht van
          sociale premies, belastingen, en andere werkgeverslasten met
          betrekking tot de uitzendkrachten en gedetacheerden. Indien
          Backofficer tekortschiet in deze verplichtingen, is zij aansprakelijk
          voor de daaruit voortvloeiende schade. Smart-Personeel zal de
          opdrachtgever zo spoedig mogelijk op de hoogte brengen van eventuele
          tekortkomingen van Backofficer.
          <b>6.2. Beperking van Aansprakelijkheid van Smart-Personeel</b>
          Smart-Personeel is niet aansprakelijk voor indirecte schade zoals
          gevolgschade, winstderving of schade door vertraging, tenzij sprake is
          van opzet of grove nalatigheid van Smart-Personeel. De
          aansprakelijkheid van Smart-Personeel voor directe schade is beperkt
          tot een maximum van €500.000 per gebeurtenis, waarbij een reeks van
          samenhangende gebeurtenissen als één gebeurtenis wordt beschouwd.
          <b>6.3. Aansprakelijkheid van de Opdrachtgever</b>
          De opdrachtgever is aansprakelijk voor schade aan medewerkers of
          ZZP’ers van Smart-Personeel indien deze schade is veroorzaakt door een
          gebrek in de arbeidsomstandigheden.
          <b>6.4. Overmacht</b>
          In geval van overmacht, waaronder ziekte, oorlog of natuurrampen,
          worden de verplichtingen van Smart-Personeel opgeschort zolang de
          situatie voortduurt. Indien de overmacht langer dan 60 dagen
          voortduurt, hebben beide partijen het recht de overeenkomst
          schriftelijk te ontbinden zonder recht op schadevergoeding.
          <b>7. VERZEKERINGEN</b>
          <b>7.1. Verzekering voor Uitzendkrachten en Gedetacheerden</b>
          De opdrachtgever dient voldoende verzekerd te zijn voor risico’s met
          betrekking tot de ter beschikking gestelde medewerkers, zoals
          wettelijke aansprakelijkheid en schade door arbeidsongevallen op de
          werkplek.
          <b>7.2. Verzekeringen van ZZP’ers</b>
          ZZP'ers zijn zelf verantwoordelijk voor het afsluiten van hun
          verzekeringen, zoals aansprakelijkheids- en
          arbeidsongeschiktheidsverzekeringen.
          <b>8. PRIVACY EN VERWERKING VAN PERSOONSGEGEVENS</b>
          <b>8.1. Privacy beleid</b>
          Smart-Personeel heeft een privacy beleid in overeenstemming met de
          AVG, dat kan worden ingezien op de website van Smart-Personeel.
          <b>8.2. Verwerking van Persoonsgegevens volgens AVG</b>
          Smart-Personeel verwerkt persoonsgegevens conform de AVG en neemt
          passende maatregelen om de veiligheid van de gegevens te waarborgen.
          <b>9. GESCHILLENREGELING</b>
          <b>9.1. Klachtenprocedure</b>
          Klachten over de dienstverlening van Smart-Personeel dienen
          schriftelijk te worden gemeld en worden binnen 30 dagen afgehandeld.
          <b>9.2. Toepasselijk Recht en Forumkeuze</b>
          Op deze voorwaarden en overeenkomsten is Nederlands recht van
          toepassing. Geschillen worden bij voorkeur voorgelegd aan de bevoegde
          rechtbank in de regio waar Smart-Personeel is gevestigd, tenzij
          partijen gezamenlijk anders overeenkomen.
          <b>10. OVERIGE BEPALINGEN</b>
          <b>10.1. Samenwerking met Backofficer</b>
          Smart-Personeel werkt samen met Backofficer voor de levering van
          payroll-diensten. De samenwerking met Backofficer maakt integraal deel
          uit van de dienstverlening van Smart-Personeel aan de opdrachtgever.
          Door akkoord te gaan met de dienstverlening van Smart-Personeel, stemt
          de opdrachtgever ook in met de voorwaarden die gelden tussen
          Backofficer en de opdrachtgever, zoals vastgelegd in de algemene
          voorwaarden van Backofficer. De voorwaarden van Backofficer zijn van
          toepassing voor zover zij niet in strijd zijn met de bepalingen in
          deze algemene voorwaarden van Smart-Personeel. In geval van
          tegenstrijdigheden prevaleren de voorwaarden van Smart-Personeel,
          tenzij anders schriftelijk is overeengekomen.
          <b>10.2. Ongeldigheid van Bepalingen</b>
          Indien een bepaling uit deze voorwaarden ongeldig is, blijven de
          overige bepalingen onverminderd van kracht. Smart-Personeel en de
          opdrachtgever treden in overleg om een nieuwe bepaling overeen te
          komen die zoveel mogelijk aansluit bij de bedoeling van de
          oorspronkelijke bepaling.
        </TermsResultCard>
      </TermsPageTable>

      {/* Terms: Newsletter */}
      <Newsletter />

      {/* Terms: Footer */}
      <Footer />
    </TermsPageContainer>
  );
}

export default Terms;
